import { theme } from 'Assets/Styles/theme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

export const muiTheme = getMuiTheme({
  palette: {
    secondary: { main: theme.colors.primary },
  },
  datePicker: {
    calendarTextColor: theme.colors.secondary,
    headerColor: theme.colors.primary,
    selectColor: theme.colors.primary,
    textColor: theme.colors.white,
  },
  timePicker: {
    calendarTextColor: theme.colors.secondary,
    headerColor: theme.colors.primary,
    selectColor: theme.colors.primary,
    accentColor: theme.colors.primary,
    textColor: theme.colors.white,
  },
  flatButton: {
    primaryTextColor: theme.colors.primary,
  },
})



// WEBPACK FOOTER //
// ./src/Assets/Styles/muiTheme.js